import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useOrderStore } from "~/stores/use-order-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { CheckoutScreen } from "./checkout-screen";

export default function CheckoutDialog() {
  const { checkoutOpen, setCheckoutOpen } = useOrderStore();
  const isLoading = useOrderStore((state) => state.isLoading);

  const { t } = useTranslation("common");

  const handleDialog = (open: boolean) => {
    setCheckoutOpen(open);
  };

  return (
    <Dialog open={checkoutOpen} onOpenChange={handleDialog}>
      <DialogContent
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="max-w-xl w-full"
      >
        <DialogHeader canClose={!isLoading}>
          <DialogTitle>{t("checkout")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <CheckoutScreen onClose={() => handleDialog(false)} />
      </DialogContent>
    </Dialog>
  );
}
